import { memo } from "react"
import { useAppSelector } from "../../../../hooks/useRedux"
import useTimeStepsDensity from "../../../../hooks/useTimeStepsDensity"
import { useMasterTimeline } from "../../../../hooks/useMasterTimeline"
import { useIsCellVisible } from "../../../../hooks/useTimelineViewport"
import TimeStamp from "./TimeStamp"

interface Props {
    width: number
    index: number
    handleClickTimeStamp: (time: number) => void
}

const TimeStampWrapper = memo(({ width, index, handleClickTimeStamp }: Props) => {
    const timelinePreferences = useAppSelector((state) => state.timelinePreferences.value)
    const tweensPerSec: number = timelinePreferences.timelineTweensPerSec

    const duration: number = useMasterTimeline().masterTimelineDuration
    const { timeStepsDensity } = useTimeStepsDensity()
    const timelineRowWidth: number = width
    const tweenWidth: number = duration > 0 ? timelineRowWidth / duration : timelineRowWidth // width per sec
    const timeStampWidth: number = tweenWidth / tweensPerSec - 2
    const timeStepX: number = tweenWidth / tweensPerSec

    const getTimeStampWidth = () => (timeStepsDensity - index === 0 ? tweenWidth : timeStampWidth)

    // keep in sync with the geometry TimeStamp actually renders with
    const isInViewport = useIsCellVisible(index * timeStepX + 2, getTimeStampWidth())

    // off-screen timestamps render nothing — the placeholder was a <div> per stamp
    if (!isInViewport) return null

    return <TimeStamp index={index} width={width} handleClickTimeStamp={handleClickTimeStamp} />
})

export default TimeStampWrapper
